import { useCallback, useState } from "react";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { resetInitializeContract } from "@academy-context/write/application/use-cases/external-provider/subcontracting-contract-enable/enable-subcontracting-contract";
import { selectContractInitialization } from "@academy-context/write/application/use-cases/external-provider/subcontracting-contract-enable/selectors/subcontracting-contract-enable-selectors";

export const useContractInitialization = () => {
  const dispatch = useAppDispatch();
  const { toast } = useToast();
  const { signatureLink } = useAppSelector(selectContractInitialization);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [contractSignedOptimistically, setContractSignedOptimistically] = useState(false);

  // Le formulaire du signataire a obtenu le lien de signature
  const handleContractInitialized = useCallback(() => setIsDialogOpen(true), []);

  const handleSignatureDone = useCallback(() => {
    setContractSignedOptimistically(true);
    toast({ description: "Le contrat a été signé avec succès." });
  }, [toast]);

  const handleCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
    dispatch(resetInitializeContract());
  }, [dispatch]);

  const handleDeclined = useCallback(() => {
    setIsDialogOpen(false);
    toast({ description: "La signature du contrat a été déclinée." });
    dispatch(resetInitializeContract());
  }, [dispatch, toast]);

  const handleError = useCallback(() => {
    setIsDialogOpen(false);
    toast({ description: "Une erreur est survenue lors de la signature du contrat.", variant: "destructive" });
    dispatch(resetInitializeContract());
  }, [dispatch, toast]);

  return {
    isDialogOpen,
    signatureLink,
    contractSignedOptimistically,
    handleContractInitialized,
    handleSignatureDone,
    handleCloseDialog,
    handleDeclined,
    handleError,
  };
};
